var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 38.0518 56.8278 45.3628 51.665 50.7512C46.2045 56.4512 38.5166 60 30 60C21.4834 60 13.7955 56.4512 8.33499 50.7512C3.17225 45.3627 0 38.0518 0 30C0 13.4316 13.4316 0 30 0C46.5684 0 60 13.4316 60 30Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.6097C36.7687 31.6097 42.2558 26.1226 42.2558 19.3539C42.2558 12.5852 36.7687 7.09814 30 7.09814C23.2313 7.09814 17.7442 12.5852 17.7442 19.3539C17.7442 26.1226 23.2313 31.6097 30 31.6097Z",
    fill: "#C0C5C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6484 48.2705C50.4082 48.5421 50.1624 48.8092 49.9113 49.0711C44.8927 54.3097 37.8272 57.5713 29.9999 57.5713C22.1726 57.5713 15.1072 54.3097 10.0886 49.0711C9.83756 48.8093 9.59175 48.5421 9.35147 48.2705C13.0449 40.5848 20.9031 35.2793 29.9999 35.2793C39.0968 35.2793 46.9551 40.5849 50.6484 48.2705Z",
    fill: "#C0C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/defaultImg.741a697c5134c164e338ce99a34436d7.svg";
export { ForwardRef as ReactComponent };